const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOtherDevices(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.41421
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.02817,0,0,2.02817,11.8288,4.72077)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.997,5.001L9.997,0L1.999,0L1.999,5.001L0,5.001L0,12.999C0,14.652 1.344,16.001 3.002,16.001L5.001,16.001L5.001,20L7.001,20L7.001,16.001L9,16.001C10.653,16.001 12.002,14.657 12.002,12.999L12.002,5.001L9.997,5.001ZM3.999,1.999L7.998,1.999L7.998,5.001L3.999,5.001L3.999,1.999Z",
    style: {
      fill: "rgb(136,136,136)"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOtherDevices);
export default __webpack_public_path__ + "static/media/other_devices.65a58e1aa00d6c2036e65aefa062c0f7.svg";
export { ForwardRef as ReactComponent };